export const emailLogTypes = {
  quote: 'quote',
  order: 'salesOrder',
  invoice: 'invoice',
};

export const shipmentStatuses = {
  new: 'Created',
  quote: 'Quote',
  pendingReview: 'Pending Review',
  scheduled: 'Scheduled',
  inTransit: 'In Transit',
  delivered: 'Delivered',
  completed: 'Complete',
};

export const companyEmailDomain = '@containers.com';

export const paymentTypeIds = {
  visa: 'VISA',
  amex: 'AMEX',
  discover: 'DISCOVER',
  masterCard: 'MASTERCARD',
  eAch: 'eACH',
  cash: 'Cash',
  merchandiseCredit: 'Merchandise Credit',
  appliedCredit: 'Applied Credit',
};

export const paymentTypes = {
  visa: 1,
  amex: 2,
  discover: 3,
  masterCard: 4,
  jcb: 5,
  dinersClub: 6,
  eACH: 99,
};

export const customerTypes = {
  customer: 1203,
  prospect: 1204,
};

export const rowStatusFlagOptions = [
  { value: 704, label: 'Active' },
  { value: 700, label: 'Inactive' },
];

//Shipping Queue Enums
export const addressType = {
  origin: 'origin',
  destination: 'destination',
  warehouse: 'warehouse',
  finish: 'finish',
};

export const customerNameMaxLength = 50;

export const phoneMaxLength = 20;
